import { Component, OnInit, Optional, Inject, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { MemberByUserProfileService } from './service/member-by-user-profile.service';
import { AddMemberByInvitationComponent } from '../add-member-by-invitation/add-member-by-invitation.component';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { CommonHelper } from '../../../../utilities/common.helper';


@Component({
  selector: 'kt-add-member-by-user-profile',
  templateUrl: './add-member-by-user-profile.component.html',
  styleUrls: ['./add-member-by-user-profile.component.scss'],
  providers: [MemberByUserProfileService]
})
export class AddMemberByUserProfileComponent implements OnInit {

  public dropdownSearch = HEC_CONSTANTS.DROPDOWN_FILTER_USER_PROFILE
  public dropdownCategoryTypes = HEC_CONSTANTS.DROPDOWN_CATEGORY_TYPE
  public dropdownPanels: any = null
  public dropdownCategories: any = null
  public dropdownMajor:any = null
  public dropdownInstitute:any = null

  public searchForm: FormGroup;
  public hintMessage: string = null
  public selectionViolation:string = null

  public isDataPresent: boolean = true
  public showForm: boolean = false
  public showTableOrAddNew: boolean = false
  public showNestedForm: boolean = false
  public showInvitationButton:boolean = false
  public showPanelDropdown:boolean = false
  public showCategoryType:boolean =false

  private EMAIL_REGEX = CommonHelper.EMAIL_REGEX;
  public maxlengthValue:number = 100

  public pageState:any = null

  public filteredMajors: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredInstitutions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();


  constructor(private dialogRef: MatDialogRef<AddMemberByUserProfileComponent>,
    public matDialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private memberByUserProfileService: MemberByUserProfileService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
  ) { }


  
  ngOnInit() {
    this.createSearchForm()
    this.pageState = this.data.pageState

    if(!this.data.hideCategoryAndPanels){
      this.getCategoryList(this.data.panelData.panelId ? this.data.panelData.panelId : 0)
      this.searchForm.controls.categoryName.setValidators(Validators.required)
    }

    if(this.pageState == 'Disciplinary'){
      this.searchForm.controls.disciplinaryCategoryName.setValidators(Validators.required)
      this.showCategoryType = true
    }
    else{
      this.showCategoryType = false

    }
  
  }


  private createSearchForm(): void {
    this.searchForm = this.fb.group({
      searchType: ['', Validators.required],
      searchData: ['', Validators.required],
      fullName: [''],
      commonProfileId: [null],
      categoryName: [null],
      disciplinaryCategoryName:[null],
      majorSubjectId:[null],
      minorSubject:[null],
      majorFilter:[null],
      instituteId:[null],
      instituteFilter:[null],
      rgaRoleViewDtoList: this.fb.array([]),
    })
  }

  public getRgaRolesList(form): any {
    return form.controls.rgaRoleViewDtoList.controls;
  }

  public addNewListMember(data): void {
    const rgaRoleViewDtoListValues = this.searchForm.controls.rgaRoleViewDtoList as FormArray;
    let newRow = this.fb.group({
      panelId:new FormControl(null),
      batchId: new FormControl(this.data.batchId ? this.data.batchId : null),
      subBatchId: new FormControl(this.data.grantId ? this.data.grantId : null),
      commonProfileId: new FormControl(data.commonProfileId ? data.commonProfileId : null),
      cpProcessCategoryId: new FormControl({ value: data.cpProcessCategoryId ? data.cpProcessCategoryId : null, disabled: true }),
      rgaPanelMemberId: new FormControl({ value: data.rgaPanelMemberId ? data.rgaPanelMemberId : null, disabled: true }),
      panelName: new FormControl({ value: data.panelName ? data.panelName : null, disabled: true }),
      contactNumber: new FormControl({ value: data.contactNumber ? data.contactNumber : null, disabled: true }),
      fullName: new FormControl({ value: data.fullName ? data.fullName : null, disabled: true }),
      email: new FormControl({ value: data.email ? data.email : null, disabled: true }),
      isChecked: new FormControl(null)
    });
    rgaRoleViewDtoListValues.push(newRow);
  }

  public deleteRoleValues(rgaPanelMemberIndex): void {
    const rgaRoleViewDtoListValues = this.searchForm.controls.rgaRoleViewDtoList as FormArray;
    rgaRoleViewDtoListValues.removeAt(rgaPanelMemberIndex);
  }

  private clearFormArray = () => {
    let currentrgaRoleViewDtoList = this.searchForm.controls.rgaRoleViewDtoList as FormArray;
    let currentLength = currentrgaRoleViewDtoList.length;
    for (let i = 0; i < currentLength; i++) {
      currentrgaRoleViewDtoList.removeAt(0);
    }
  }

  public addPanelAndCategory(): void {
    
    if(!(this.pageState == 'Administrative') ){
     
      // this.searchForm.controls.majorSubjectId.setValidators(Validators.required)
      // this.searchForm.controls.minorSubject.setValidators(Validators.required)
      this.getMajorList()
      this.getInstitutionList()
    }

    if(!(this.pageState == 'Disciplinary') && !(this.pageState == 'Administrative')){
      this.searchForm.addControl('panelName', this.fb.control('', Validators.required));
  
      this.getPanelsList(this.data.grantId) 
      this.showPanelDropdown = true
    }
    if(this.pageState == 'Disciplinary' || this.pageState == 'Thematic' || this.pageState == 'JMP' || this.pageState == 'Steering Committee' || this.pageState == 'HLEP'){
      this.searchForm.controls.disciplinaryCategoryName.setValidators(Validators.required)
      this.showCategoryType = true
    }
    this.showNestedForm = true
    
  }

  public onButtonClick(button?) {
    this.dialogRef.close(button);
  }


  public findPanelId(label):void{

    let panelId = (this.dropdownPanels as any).find((v: any) => v.label == label).value;
    if (panelId) 
    {
    for (let i = 0; i <= this.searchForm.getRawValue().rgaRoleViewDtoList.length - 1; i++) {
      let panelNameValue = this.searchForm.controls.rgaRoleViewDtoList['controls'][i].controls.panelName.value
      if (panelNameValue == null || panelNameValue == undefined || panelNameValue == '') {
        this.searchForm.controls.rgaRoleViewDtoList['controls'][i].controls.panelId.setValue(panelId)
      }     
  }
}
  }

  public shouldShowCategoryAndPanelDropdown():boolean{
    if(this.data){
      return this.data.hideCategoryAndPanels
    }
  }

  
  public filterMembers(): void {
    this.selectionViolation = null
    this.showForm = false
    this.showNestedForm = false
    this.showTableOrAddNew = false
    this.showInvitationButton =false
    this.clearFormArray();
    this.searchForm.controls.fullName.reset()
    this.searchForm.controls.commonProfileId.reset()
    this.searchForm.controls.categoryName.reset()   
    if (this.searchForm.controls.disciplinaryCategoryName) {
      this.searchForm.controls.disciplinaryCategoryName.reset()
    }
    this.searchForm.controls.majorSubjectId.reset()
    this.searchForm.controls.minorSubject.reset()
    this.searchForm.controls.instituteId.reset()
    if (this.searchForm.controls.panelName) {
      this.searchForm.controls.panelName.reset()
    }

    // this.markFormsTouched();
    if(!this.searchForm.controls.searchType.valid || !this.searchForm.controls.searchData.valid){
      return
    }

    let searchType = this.searchForm.value.searchType ? this.searchForm.value.searchType : null
    let searchData = this.searchForm.value.searchData ? this.searchForm.value.searchData : null

    this.isDataPresent = false
    this.memberByUserProfileService.getMemberList(searchType, searchData).subscribe(response => {
      this.isDataPresent = true
      if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
        if (response['data']) {
          this.clearFormArray();
          this.showForm = true
          this.showInvitationButton = false
          response['data']['personName'] ? this.searchForm.controls.fullName.setValue(response['data']['personName']) : this.searchForm.controls.fullName.setValue(null)
          response['data']['profileId'] ? this.searchForm.controls.commonProfileId.setValue(response['data']['profileId']) : this.searchForm.controls.commonProfileId.setValue(null)
        //  delete response['data']['rgaRoleViewDtoList'][1]
        //  delete response['data']['rgaRoleViewDtoList'][2]
        //  delete response['data']['rgaRoleViewDtoList'][3]

        // response['data']['rgaRoleViewDtoList'][1].panelName = null
          if (response['data'] && response['data']['rgaRoleViewDtoList'] && response['data']['rgaRoleViewDtoList'].length > 0) {
            this.showTableOrAddNew = true
            for (let i = 0; i < response['data']['rgaRoleViewDtoList'].length; i++) {
              if(response['data']['rgaRoleViewDtoList'][i].panelName == null && (!this.data.hideCategoryAndPanels || this.pageState == 'Disciplinary')){
               
                this.addPanelAndCategory()

              }
              this.addNewListMember(response['data']['rgaRoleViewDtoList'][i])
            }
          }

        //  if((!response['data']['rgaRoleViewDtoList'] || response['data']['rgaRoleViewDtoList'].length == 0)){
        //   this.addPanelAndCategory()
        //   }
        }
        else{
          this.showInvitationButton = true
        }
      } else if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND) {
        // this.showTable = false
        this.showForm = false
        this.showInvitationButton = true
        this.sharedService.showError(response['statusDescription'], 'OK', 'error-snackbar');
      }
      else if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.SEARCH_COUNT_LIMIT_VIOLATED) {
        // this.showTable = false
        this.showForm = false
        this.showInvitationButton = false
        this.sharedService.showError(response['statusDescription'], 'OK', 'error-snackbar');
      } else {
        // this.showTable = false
        this.showForm = false
        this.showInvitationButton = true
        this.sharedService.showError('Something went wrong', 'OK', 'error-snackbar');
      }
    }, (err) => {
      // this.showTable = false
      this.isDataPresent = true
      this.showForm = false
      this.showInvitationButton = false
      this.sharedService.showError('something went wrong', 'OK', 'error-snackbar');
    })

  }

  public addMembers(): void {
    this.markFormsTouched();
    if(this.pageState == 'Administrative'){
      let payload = this.constructPayloadForAdministrativePanel()
      console.log('payload', payload)  
      if(payload.rgaRoleViewDtoList && payload.rgaRoleViewDtoList.length == 0){
        this.selectionViolation = 'Please Select Atleast One Record'
      }
      else{
        this.selectionViolation=''
      } 
      if (!this.formValid(payload))
        return;
      this.isDataPresent = false
      this.memberByUserProfileService.saveNewMemberDetailsInAdministrative(payload)
        .subscribe(
          (res: any) => {
            this.isDataPresent = true
            if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
              this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
            }
            else {
              this.dialogRef.close({ payload , res })
              this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
            }
          },
          (err) => {
            this.isDataPresent = true
            if (+err.error.statusCode == 401) {
              this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
            } else {
            }
          }
        )
  
    }

    else if(this.pageState == 'JMP' || this.pageState == 'HLEP' || this.pageState == 'Steering Committee'){


      let payload = this.constructPayloadTypeTwo()
      console.log('payload', payload)  
      if(payload.rgaRoleViewDtoList && payload.rgaRoleViewDtoList.length == 0){
        this.selectionViolation = 'Please Select Atleast One Record'
      }
      else{
        this.selectionViolation=''
      } 
      if (!this.formValid(payload))
        return;
      this.isDataPresent = false
      this.sharedService.searchProfileCasesTypeTwo(payload,this.pageState)
        .subscribe(
          (res: any) => {
            this.isDataPresent = true
            if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
              this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
            }
            else {
              // this.dialogRef.close({ payload })
              this.dialogRef.close({ payload , res })
              this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
            }
          },
          (err) => {
            this.isDataPresent = true
            if (+err.error.statusCode == 401) {
              this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
            } else {
            }
          }
        )





    }

    else{

    let payload = this.constructPayload()
    console.log('payload', payload)  
    if(payload.rgaRoleViewDtoList && payload.rgaRoleViewDtoList.length == 0){
      this.selectionViolation = 'Please Select Atleast One Record'
    }
    else{
      this.selectionViolation=''
    } 
    if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    this.sharedService.saveNewMemberDetails(payload)
      .subscribe(
        (res: any) => {
          this.isDataPresent = true
          if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
          }
          else {
            // this.dialogRef.close({ payload })
            this.dialogRef.close({ payload , res })
            this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
          }
        },
        (err) => {
          this.isDataPresent = true
          if (+err.error.statusCode == 401) {
            this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
          } else {
          }
        }
      )

    }

  }

  public enableSearchButton(): boolean {
    return (this.searchForm.value.searchType != '' && this.searchForm.value.searchType != null && this.searchForm.value.searchType != undefined
      && this.searchForm.value.searchData != '' && this.searchForm.value.searchData != null && this.searchForm.value.searchData != undefined)
  }


  public selectAllRows(event):void{
    console.log(event)
    if(event.target.checked == true){
      for (let i = 0; i <= this.searchForm.value.rgaRoleViewDtoList.length - 1; i++) {
        this.searchForm.controls.rgaRoleViewDtoList['controls'][i].controls.isChecked.setValue(true)
      }
    }else if(event.target.checked == false){
      for (let i = 0; i <= this.searchForm.value.rgaRoleViewDtoList.length - 1; i++) {
        this.searchForm.controls.rgaRoleViewDtoList['controls'][i].controls.isChecked.setValue(false)
      }
    }
 
  }

  public getHint(hintValue): void {
    this.showInvitationButton = false
    this.searchForm.controls.searchData.reset();
    if (hintValue) {
      if (hintValue == 'cnic') {
        this.hintMessage = '4230132324324..'      
        this.maxlengthValue = 13
        this.cdr.detectChanges()
        this.searchForm.get('searchData').clearValidators();
        this.searchForm.controls.searchData.setValidators(Validators.compose([Validators.required,Validators.maxLength(13),Validators.minLength(13)]))
       

      }

      else if (hintValue == 'email') {
        this.hintMessage = 'abc@gmail.com..'
        this.maxlengthValue = 80
        this.cdr.detectChanges()
        this.searchForm.get('searchData').clearValidators();
        // this.searchForm.get('searchData').updateValueAndValidity();
        this.searchForm.controls.searchData.setValidators(Validators.compose([Validators.required,Validators.pattern(this.EMAIL_REGEX),Validators.maxLength(80)]))
        
      }
      else {
        this.hintMessage = null
        this.searchForm.get('searchData').clearValidators();
        this.searchForm.get('searchData').updateValueAndValidity();
      }
    }

  }


  private getPanelsList(grantId) {
    this.sharedService.getPanelsListForTeamManagement(grantId).subscribe(response => {
      if (response) {
        console.log(response['data'])
        this.dropdownPanels = response['data']
      }
      else {
        this.dropdownPanels = []
      }
    })
  }


  private getCategoryList(panelId) {
    this.sharedService.getCategoryListForTeamManagement(panelId).subscribe(response => {
      if (response) {
        console.log(response['data'])
        this.dropdownCategories = response['data']
      }
      else {
        this.dropdownCategories = []
      }
    })
  }

  
  private getMajorList() {
    this.sharedService.getMajorList().subscribe(response => {
      if (response) {
        this.dropdownMajor = response['data']
        this.filteredMajors.next(this.dropdownMajor.slice());
        this.searchForm.controls.majorFilter.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterMajors();
        });
      }
      else{
        this.dropdownMajor = []
      }
    })
  }

  private getInstitutionList() {
    this.sharedService.getInstituteList().subscribe(response => {
      if (response) {
        this.dropdownInstitute = response['data']
        this.filteredInstitutions.next(this.dropdownInstitute.slice());
        this.searchForm.controls.instituteFilter.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterInstitutes();
        });
    
      }
      else{
        this.dropdownInstitute = []
      }
    })
  }

  protected filterInstitutes() {
    if (!this.dropdownInstitute) {
      return;
    }
    // get the search keyword
    let search = this.searchForm.controls.instituteFilter.value;
    if (!search) {
      this.filteredInstitutions.next(this.dropdownInstitute.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredInstitutions.next(
      this.dropdownInstitute.filter(member => (
        
        (member.label ? member.label.toLowerCase().indexOf(search) > -1 : null))))
  }


  protected filterMajors() {
    if (!this.dropdownMajor) {
      return;
    }
    // get the search keyword
    let search = this.searchForm.controls.majorFilter.value;
    if (!search) {
      this.filteredMajors.next(this.dropdownMajor.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredMajors.next(
      this.dropdownMajor.filter(member => (
        
        (member.label ? member.label.toLowerCase().indexOf(search) > -1 : null))))
  }



  private markFormsTouched(): void {
    CommonHelper.markFormGroupTouched(this.searchForm);

  }

  private formValid(payload): boolean {
    return this.searchForm.valid && payload.rgaRoleViewDtoList.length > 0
  }

  private constructPayload() {
    var rgaRoleViewDtoList = []
    if (this.showNestedForm && this.searchForm.getRawValue().rgaRoleViewDtoList.length == 0) {
      let obj = {
        batchId: this.data.batchId,
        subBatchId: this.data.grantId,
        commonProfileId: this.searchForm.value.commonProfileId,
        fullName: this.searchForm.value.fullName,
        panelName: this.searchForm.value.panelName,
        categoryName: this.searchForm.value.categoryName
      }
      rgaRoleViewDtoList.push(obj)
    }

    let payload = {

      addNewMember:true,
      addMajorMinorSubject : false,
      panelId: this.data.panelData.panelId ? this.data.panelData.panelId : null,
      panelName: this.data.panelData.panelName ? this.data.panelData.panelName : null,
      rgaRoleViewDtoList:  this.searchForm.getRawValue().rgaRoleViewDtoList.length == 1 ? this.searchForm.getRawValue().rgaRoleViewDtoList :  this.getRgaRoleDtoList()
    }

    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ?  delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
      

      if(this.pageState == 'Thematic'){
        payload.rgaRoleViewDtoList[i].categoryName = this.searchForm.value.categoryName ? this.searchForm.value.categoryName : null
        payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.searchForm.value.disciplinaryCategoryName ? this.searchForm.value.disciplinaryCategoryName : null

      }
      else if(this.pageState == 'Disciplinary'){
        payload.rgaRoleViewDtoList[i].categoryName = this.searchForm.value.disciplinaryCategoryName ? this.searchForm.value.disciplinaryCategoryName : null
      }
      else{

      }
     
      if(payload.rgaRoleViewDtoList[i].panelName == null || payload.rgaRoleViewDtoList[i].panelName == '' || payload.rgaRoleViewDtoList[i].panelName == undefined ){
       
       if(!(this.pageState == 'Administrative')){
        payload.rgaRoleViewDtoList[i].panelName = this.searchForm.value.panelName ? this.searchForm.value.panelName : null
        // payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.searchForm.value.disciplinaryCategoryName ? this.searchForm.value.disciplinaryCategoryName : null

       }
        payload.rgaRoleViewDtoList[i].majorSubjectId = this.searchForm.value.majorSubjectId ? this.searchForm.value.majorSubjectId : null
        payload.rgaRoleViewDtoList[i].minorSubject = this.searchForm.value.minorSubject ? this.searchForm.value.minorSubject : null
        payload.rgaRoleViewDtoList[i].instituteId = this.searchForm.value.instituteId ? this.searchForm.value.instituteId : null
        
        if( payload.rgaRoleViewDtoList[i].majorSubjectId){
          payload.rgaRoleViewDtoList[i].majorSubject =   (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[i].majorSubjectId).label;

        }
        payload.addMajorMinorSubject = true
      }
      delete payload.rgaRoleViewDtoList[i].isChecked
    }
   
    return payload;
  }

  private constructPayloadTypeTwo() {
    var rgaRoleViewDtoList = []
    if (this.showNestedForm && this.searchForm.getRawValue().rgaRoleViewDtoList.length == 0) {
      let obj = {
        batchId: this.data.batchId,
        subBatchId: this.data.grantId,
        commonProfileId: this.searchForm.value.commonProfileId,
        fullName: this.searchForm.value.fullName,
        panelName: this.searchForm.value.panelName,
        categoryName: this.searchForm.value.categoryName
      }
      rgaRoleViewDtoList.push(obj)
    }
    let payload = {
      addNewMember:true,
      addMajorMinorSubject : false,
      rgaRoleViewDtoList:  this.searchForm.getRawValue().rgaRoleViewDtoList.length == 1 ? this.searchForm.getRawValue().rgaRoleViewDtoList :  this.getRgaRoleDtoList()
    }
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      payload.rgaRoleViewDtoList[i].rgaPanelMemberId ?  delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null     
      
      if(this.pageState == 'JMP' || this.pageState == 'Steering Committee' || this.pageState == 'HLEP' ){
        payload.rgaRoleViewDtoList[i].categoryName = this.searchForm.value.categoryName ? this.searchForm.value.categoryName : null
        payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.searchForm.value.disciplinaryCategoryName ? this.searchForm.value.disciplinaryCategoryName : null
      }   
      
      if(payload.rgaRoleViewDtoList[i].panelName == null || payload.rgaRoleViewDtoList[i].panelName == '' || payload.rgaRoleViewDtoList[i].panelName == undefined ){
       
       if(!(this.pageState == 'Administrative')){
        payload.rgaRoleViewDtoList[i].panelName = this.searchForm.value.panelName ? this.searchForm.value.panelName : null
        // payload.rgaRoleViewDtoList[i].disciplinaryCategoryName = this.searchForm.value.disciplinaryCategoryName ? this.searchForm.value.disciplinaryCategoryName : null

       }
        payload.rgaRoleViewDtoList[i].majorSubjectId = this.searchForm.value.majorSubjectId ? this.searchForm.value.majorSubjectId : null
        payload.rgaRoleViewDtoList[i].minorSubject = this.searchForm.value.minorSubject ? this.searchForm.value.minorSubject : null
        payload.rgaRoleViewDtoList[i].instituteId = this.searchForm.value.instituteId ? this.searchForm.value.instituteId : null
        
        if( payload.rgaRoleViewDtoList[i].majorSubjectId){
          payload.rgaRoleViewDtoList[i].majorSubject =   (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[i].majorSubjectId).label;

        }
        payload.addMajorMinorSubject = true
      }
      delete payload.rgaRoleViewDtoList[i].isChecked
    }
   
    return payload;
  }


  private constructPayloadForAdministrativePanel(){
  
    let payload = {
      addNewMember : true,
     panelName: this.data.panelData.panelName,
    rgaRoleViewDtoList:this.searchForm.getRawValue().rgaRoleViewDtoList.length == 1 ? this.searchForm.getRawValue().rgaRoleViewDtoList :  this.getRgaRoleDtoList()
  }

  for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
    payload.rgaRoleViewDtoList[i].categoryName = this.data.panelData.panelName ? this.data.panelData.panelName : null

    payload.rgaRoleViewDtoList[i].rgaPanelMemberId ?  delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId : null
    // if(payload.rgaRoleViewDtoList[i].panelName == null || payload.rgaRoleViewDtoList[i].panelName == '' || payload.rgaRoleViewDtoList[i].panelName == undefined ){
    //   payload.rgaRoleViewDtoList[i].panelName = this.searchForm.value.panelName ? this.searchForm.value.panelName : null
    // }
    delete payload.rgaRoleViewDtoList[i].isChecked


  }
  
  return payload
  }
  

  private getRgaRoleDtoList(){
    let rgaRoleViewDtoList = []
    for (let i = 0; i <= this.searchForm.getRawValue().rgaRoleViewDtoList.length - 1; i++) {
      if (this.searchForm.controls.rgaRoleViewDtoList['controls'][i].controls.isChecked.value == true) {
        rgaRoleViewDtoList.push(this.searchForm.getRawValue().rgaRoleViewDtoList[i])
      }
    }
    return rgaRoleViewDtoList
  }
  public enableAddButton():boolean{
    return ((this.showTableOrAddNew && this.searchForm.value.rgaRoleViewDtoList && this.searchForm.value.rgaRoleViewDtoList.length > 0)
     || (this.showNestedForm))
  }

  public addMemberByInvitation(): void {
    const dialogRef = this.matDialog.open(AddMemberByInvitationComponent, {
      width: '80vw',
      height: '80vh',
      // backdropClass: 'custom-scrutiny-popup',
      panelClass: 'custom-scrutiny-popup',
      // disableClose: true,
      autoFocus: false,
      data: { grantId: this.data.grantId ? this.data.grantId : null, 
        panelData: this.data.panelData ? this.data.panelData : null, 
        batchId: this.data.batchId ? this.data.batchId : null,
        hideCategoryAndPanels: this.data.hideCategoryAndPanels ? this.data.hideCategoryAndPanels : null,
        pageState : this.data.pageState
       }
      // data: { data: selectedRows, grantId: this.grantId ? this.grantId : null}
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.getGridData(this.grantId, this.assignmentViewForm.value.view)
      if (result) {
        this.dialogRef.close(result)
      }
    });
  }


  public keyPress(event){
    if(this.searchForm){
      if(this.searchForm.value.searchType == 'cnic'){
        CommonHelper.keyPress(event)
      }
    }
    
  }

}
